import { jsx } from "react/jsx-runtime";
import { TextField, TextFieldTheme } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useForcedState, ForcedState } from "../../../contexts/forced-state-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { classes } from "./day-field-wut.st.css";
function DayFieldWUT(props) {
  const { id, className, onChange, ...rest } = props;
  const { t } = useTranslation();
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  return /* @__PURE__ */ jsx(
    TextField,
    {
      ...rest,
      type: "text",
      inputMode: "numeric",
      maxLength: 2,
      theme: TextFieldTheme.Box,
      newErrorMessage: true,
      onChange: handleChange,
      "aria-label": t("field.date.placeholder.day"),
      className: classNames(className, classes.root, classes.theme, {
        [classes.hover]: forcedHover
      })
    }
  );
  function handleChange(event) {
    props.onChange?.(event.target.value);
  }
}
export {
  DayFieldWUT
};
//# sourceMappingURL=day-field-wut.js.map
